export enum ValidationErrorMessages {
    First_Name = "Please provide a valid first name",
    Last_Name = "Please provide a valid last name",
    Email_Address = "Please provide a valid email address",
    Examiner_Number = "3-4 digit examiner number required",
    Mobile_Number_Format = "Mobile number format error: (###) ###-####",
    Mobile_Number_Invalid = "Mobile number invalid",
    Examiner_Number_Exists = "Examiner number already exists",
}